import Config from "./config.js"
import axios from "axios"
import LocaStorage from "../utils/localstorage.js"
import qs from "qs"
// 不同环境不同地址
	const apis = {
	production: '', // 线上 (生成环境)
	development: 'http://192.168.0.130:9999', // 本地 (开发环境)
	accessHomeData: '' // 其他api
  }
axios.defaults.baseURL = Config.baseUrl
axios.defaults.responseType = "json"
axios.defaults.timeout = 60 * 1000
// axios.defaults.timeout = 100;// 测试请求超时代码，勿删

/**
 * http单个请求
 * @param {object} params 请求参数
 * @param {integer} successCode 接口正常返回结果标识
 *
 * @returns Promise
 */
export default function request(params, successCode = 0) {
	const token = LocaStorage.setAge().get('token')
	const token1 = LocaStorage.setAge().get('token1')
	const token2 = LocaStorage.setAge().get('token2')
	var url = params.url // 请求路径
	var data = {
	}
	var headers
	var Authorization = params.type == 1 ? 'Basic cGxhdGZvcm06cGxhdGZvcm0=' : params.type == 2 ? 'Basic ZW50ZXJwcmlzZTplbnRlcnByaXNl' : 'Basic ZXhhbTpleGFt'
	if(!params.sentType){
		headers = {
			'Content-Type':  token ? 'application/json' : 'application/x-www-form-urlencoded',
			'Authorization': token ? token : Authorization
		}
	}else{
		let typestr = params.type ?  'application/x-www-form-urlencoded' : 'application/json'
		if(params.type == 3){
			headers = {
				'Content-Type':  typestr,
				'Authorization': Authorization
			}
		}else{
			headers = {
				'Content-Type':  typestr,
				'Authorization': token1 ? token1 : Authorization
			}
		}
	}
	
	// }else{

	// }
	var method = params.method //请求方式 
	// var token = getToken()
	// if (token) data.token = token
	// 参数
	if(Array.isArray(params.data)) data = params.data
	if (params.data != undefined) Object.assign(data, params.data)
	if(params.sentType){
		if(params.type){
			data = qs.stringify(data)
		}
	}else{
		if(!token) data = qs.stringify(data)
	}
	//异步
	return axios({
			url: url,
			method: method,
			data,
			headers
		})
		.then(res => {
			if (res) return res.data
			else return Promise.reject(res.data)
		})
		.catch(error => {
			if (error.response) {
				if(error.response.data.code == 1){
				vue.$message.error(error.response.data.msg)
			}
			if(!params.sentType){
				if(error.response.data.code == 424){
					if(error.response.data.msg){
						vue.$message.error(error.response.data.msg)
					}else{
						vue.$message.error('您的账户登录已超时，请重新登录')
					}
					localStorage.removeItem('token')
					localStorage.removeItem('userinfo')
					if(url.indexOf("/platform/support/view/") != -1){
						return Promise.reject(error.response.data)
					}else{
					 vue.$router.push({path:"/login"})
					} 
			}
			}else{
				
				if(error.response.data.code == 424){
					
					if(vue.$route.name !="endowloadDetail" && url !="/enterprise/online" && url !="/enterprise/front/appClassifyList/") vue.$message.error('您的账号登录已超时或在别处登录，请重新登录')
					localStorage.removeItem('token1')
					localStorage.removeItem('userinfo1')
					if(vue.$route.name != "orderAdmin" && vue.$route.name != 'creatOrder' && vue.$route.name !="endowloadDetail" && url !="/enterprise/online" && url !="/enterprise/front/appClassifyList/") vue.$router.push({path:"/webenterprise/login"})
			}
			}
				return Promise.reject(error.response.data)
			  }
            // const { error_code } = error
            // if (error_code === "TOKEN_ERROR") {
			// 	error.message = '登录错误'
            //     vue.$store.dispatch("member/remove_token")
            //     if (params.forceLogin) {
            //         vue.$router.push(`/login?redirect=${encodeURIComponent(vue.$router.history.current.fullPath)}`)
            //     }
            // }

           
        })
}

/**
 * 并发请求
 * @param {array} params 并发请求参数数组，传入数组中对象的顺序要匹配 data 中 url
 * @var 该方法为并发请求，数据会在全部请求完之后才返回
 * 该方法不建议使用。
 */
export function conRequest(params) {
	if (Object.prototype.toString.call(params) != "[object Array]") {
		return Promise.reject({
			code: -1,
			msg: "参数必须为数组"
		})
	}

	//同步并发
	var quest = []
	for (var i = 0; i < url.length; i++) {
		quest.push(
			axios({
				url: params[i].url,
				method: method,
				params: params[i].data
			})
		)
	}

	axios
		.all(quest)
		.then(
			axios.spread(() => {
				// 请求全部完成后执行
				var res = []
				for (let i = 0; i < arguments.length; i++) {
					res.push(arguments[i].data)
				}

				return res
			})
		)
		.catch(error => {
			// const { error_code } = error
			// if (error_code === "TOKEN_ERROR") {
			// 	error.message = '登录错误'
			//     vue.$store.dispatch("member/remove_token")
			//     if (params.forceLogin) {
			//         vue.$router.push(`/login?redirect=${encodeURIComponent(vue.$router.history.current.fullPath)}`)
			//     }
			// }
			// '请求超时，请检查网络'
			vue.$message({
				message: error,
				type: "warning"
			})

			return Promise.reject(error)
		})
}
